import { render, staticRenderFns } from "./HotArticle.vue?vue&type=template&id=6eba38da&scoped=true"
var script = {}
import style0 from "./HotArticle.vue?vue&type=style&index=0&id=6eba38da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba38da",
  null
  
)

export default component.exports